<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="pro01">
<a id="page06"></a>
<a id="page07"></a>
<div class="chapterHead">
<h2 class="chapterTitle"><span class="xrefInternal"><a href="#/contents#pro_01"><span class="bold">Prologue</span></a></span></h2></div>
<div class="chapterBody">
<p class="chapterOpenerText">In Highgate, north London, Vanessa Fitzgerald, accounts manager at Gibson, Adams and Bead Advertising Agency and mother of three, stared at her new nanny, eyes wide with disbelief.</p>
<p class="para">“Leaving?” she repeated. “You mean…a holiday?”</p>
<p class="para">“No,” said Francesca slowly and firmly. “I meeen leeving.”</p>
<p class="para">“I think she means leeeeving, dear,” said Vanessa’s husband, Dick.</p>
<p class="para">“I wunt to…erm, ’ow yoo saiy? Trrabel,” explained Francesca. There was a long pause. “Ze glawb,” she clarified.</p>
<p class="para">Vanessa scrunched up her face in concentration. “You want to…?” She trailed off.</p>
<p class="para">“Trrabel ze glawb,” repeated Dick, finishing his whiskey. “It’s very simple, darling.”</p>
<p class="para">“Dick, you are not helping,” said Vanessa. “This isn’t funny.”</p>
<p class="para">“It sounds funny.”</p>
<p class="para">“But it’s not.”</p>
<p class="para">“Righty-ho.”</p>
<p class="para">Vanessa returned her attention to Francesca.</p>
<p class="para">“You want to travel the globe? The world?” she tried.</p>
<p class="para">“Yais!” cried Francesca excitedly.</p>
<p class="para">There was a pause.</p>
<p class="para">“And you can’t take the children with you?” asked Vanessa.</p>
<p class="para">Francesca frowned at her boss.</p>
<p class="para">“Now who’s not being funny,” said Dick, putting his tumbler in the sink.</p>
<p class="para">“Well who’s going to look after them then?” shouted Vanessa suddenly. “And don’t leave that in the sink—put it in the sodding dishwasher!”</p>
<p class="para">Dick turned slowly to his wife.</p>
<p class="para">“I can’t imagine why our nannies keep leaving,” he said calmly, placing the tumbler in the dishwasher with elaborate care. “Maybe they don’t like being shouted and sworn at as much as I do.”</p>
<a id="page08"></a>
<p class="para">Vanessa shot Dick a look that hit him where it hurt. Straight between the eyes. His was a small brain, but she still knew how to hit it in a single go.</p>
<p class="para">“Or maybe,” she told him, “they’re just sick of putting your tumblers in the dishwasher for you.”</p>
<p class="para">Francesca coughed lightly. Dick and Vanessa ignored her. She’d just handed in her notice, they didn’t have to be nice to her anymore.</p>
<p class="para">“It will be me who has to find a temporary nanny,” Vanessa told her husband, “at the same time as interviewing for full-time nannies at the same time as keeping down my own job—sorry, career—because you’re too busy poncing around in that bloody excuse for a shop.”</p>
<p class="para">“I happen to work in that shop six days a week—”</p>
<p class="para">“You drink latte and scratch your balls six days a week, and you know it.”</p>
<p class="para">Dick smiled at his wife and changed the subject. Vanessa turned away from him and concentrated on the matter at hand—to keep breathing.</p>
<p class="para">God, she’d thought today had been bad enough. First the tube strike, then that bastard new client rejecting their latest offering because it “just didn’t sing to him,” and then her PA announcing that the tight abdominal bulge she’d passed off thus far as a bad case of lactose intolerance, was in fact a baby, due in four months’ time.</p>
<p class="para">The only thing that had kept Vanessa going all day had been the thought of coming home to some peace and quiet, the children all tucked up neatly in bed, some takeout—unless the nanny had happened to leave something from lunch—some vino and a video of last night’s EastEnders. Instead, she’d come home to a nanny who wanted to trrabel ze sodding glawb.</p>
<p class="para">She took a gulp of Pinot Grigio. To help with the breathing.</p>
<p class="para">“Okay, Francesca, thanks for letting us know,” she heard Dick say, as if Francesca had just mentioned that one of the children had lost a sock. Francesca left the kitchen. Dick spoke first, quietly, putting his arm round his wife’s shoulder.</p>
<p class="para">“Come on,” he said. “You didn’t even like her.”</p>
<p class="para">Vanessa whined, but Dick squeezed her tighter.</p>
<p class="para">“You know it’s true,” he whispered, kissing the top of her head. “She lost Tallulah the other day.”</p>
<p class="para">Vanessa leaned her head on his shoulder, exhausted.</p>
<p class="para">“She found her again,” she mumbled into his sweater.</p>
<p class="para">Dick snorted and put his arms round her, his hands resting gently on the curve of her back. “She can’t even speak the language properly.”</p>
<a id="page09"></a>
<p class="para">“Neither can the children,” pointed out his wife, “but I don’t want them to leave. Not for ages.”</p>
<p class="para">“Good,” said Dick. “Neither do I. Let’s have sex.”</p>
<p class="para">Vanessa tensed.</p>
<p class="para">“I’ve got a better idea,” she said. “Let’s find a new nanny, then have sex.”</p>
<p class="para">Dick sighed. He knew better than anyone that Vanessa was perfectly capable of keeping to her word if there was a principle involved.</p>
<p class="para">“How long will it take?” he asked.</p>
<p class="para">Vanessa shrugged. “Depends on how much we’re willing to pay.”</p>
<p class="para">“Well that’s easy then,” said Dick. “Let’s pay gold dust.”</p>
<p class="para">They smiled at each other. It was a deal. After all these years, Dick Fitzgerald knew exactly how to seduce his second wife.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pro01.vue?44c13a3e